<div
  [ngClass]="{
    'bigger-button': biggerButton,
    'button-with-border': borderButton,
    'cancel-button': cancelButton,
    'green-button': greenButton,
    'close-modal-button' : closeModalButton
  }"
  class="circle-button global-transition"
  (click)="performAction()">
  <h1 [ngClass]="{'gray-color' : grayIcon}" [style.fontSize.px]="iconSize" *ngIf="icon === 'plus'; else nbIconContainer">+</h1>
  <ng-template #nbIconContainer>
    <div class="d-flex align-items-center justify-content-center h-100">
      <nb-icon pack="icomoon" class="icon" [icon]="icon ?? ''" [style.fontSize.px]="iconSize"></nb-icon>
    </div>
  </ng-template>
</div>
